/**
 * Because having ALL of our images available and up to date on the dev machines
 * is pretty impractical, we'll point the images to the live URL to be able to
 * see them.
 */
export default function (text, length, clamp) {
	clamp = clamp || '...';
	let node = document.createElement('div');
	node.innerHTML = text;
	let content = node.textContent;

	return content.length > length ? content.slice(0, length) + clamp : content;
};
